export const star = "*";
export const hash = "#";
export const clear = "clear";
export const trChecker = "TR";
